/**
 * Work types for Shop jobs (PRD R7): the Field Service Service Type values that make sense for
 * a unit brought to the shop. Copied, not imported — Shop does not depend on Field Service code.
 */
export const SHOP_WORK_TYPES: readonly string[] = ['Maintenance', 'Service Call', 'Repair', 'Install', 'Non-Billable Goodwill', 'Other'];
